import { CONFIRM_COLOR, CONFIRM_ICONS, TYPE_MODAL } from '../modal-confirm-notification';

export const CANCEL_SKU_DISPATCH_NOTIFICATION = {
  typeModal: TYPE_MODAL.NOTIFICATION,
  title:
    'El despacho y todos los SKU pasarán a estado "Pre-Cancelado” en su totalidad. ¿Deseas continuar? ',
  valueButton: 'Continuar',
  valueCancelButton: 'Volver',
  color: CONFIRM_COLOR.SUCCESS,
  iconSVG: CONFIRM_ICONS.WARNING
};

export const PRINT_SUCCESS_DISPATCH_NOTIFICATION = {
  typeModal: TYPE_MODAL.INVALID,
  title: 'La(s) impresion(es) se realizaron correctamente.',
  valueButton: 'Aceptar',
  color: CONFIRM_COLOR.SUCCESS,
  iconSVG: CONFIRM_ICONS.SUCCESS
};
